import { StyledActiveCallPulsingAnim, StyledEmptyCircle, StyledErrorContainer, StyledGreenFilledCircle } from './CallIcon.styles';
import { SolidCrossIcon } from './SolidCrossIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallIconStatus = {
  ONLINE: 'ONLINE',
  BASE_PHONE: 'BASE_PHONE',
  ERROR: 'ERROR',
  EMPTY_CIRCLE: 'EMPTY_CIRCLE',
  SOLID_CROSS: 'SOLID_CROSS'
};
export const callIconStatusCircles = {
  BASE_PHONE: () => null,
  ONLINE: ({
    shouldShowActiveCallState,
    dataSeleniumTest
  }) => /*#__PURE__*/_jsx(StyledGreenFilledCircle, {
    "data-selenium-test": dataSeleniumTest,
    children: shouldShowActiveCallState && /*#__PURE__*/_jsx(StyledActiveCallPulsingAnim, {
      "data-selenium-test": "active-call-pulsing-anim"
    })
  }),
  ERROR: ({
    dataSeleniumTest
  }) => /*#__PURE__*/_jsx(StyledErrorContainer, {
    "data-selenium-test": dataSeleniumTest
  }),
  EMPTY_CIRCLE: ({
    dataSeleniumTest,
    color
  }) =>
  /*#__PURE__*/
  // @ts-expect-error - Expression produces a union type that is too complex to represent.ts(2590)
  _jsx(StyledEmptyCircle, {
    "data-selenium-test": dataSeleniumTest,
    color: color
  }),
  SOLID_CROSS: ({
    title,
    color
  }) => /*#__PURE__*/_jsx(SolidCrossIcon, {
    title: title !== null && title !== void 0 ? title : '',
    color: color
  })
};